import React from "react"
import { useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Label } from "shared/ui/label/Label"

import { AttachmentFragment } from "entities/attachments/graphql/fragments.generated"

import { ReplaceAttachmentOverlayFileInput } from "./ReplaceAttachmentOverlayFileInput"

interface ReplaceAttachmentOverlayNewFileStepProps {
  newFile: AttachmentFragment | null
  onUpload: (file: FilePreview) => Promise<ApiResponse<unknown>>
}

export const ReplaceAttachmentOverlayNewFileStep = React.memo(
  ({ newFile, onUpload }: ReplaceAttachmentOverlayNewFileStepProps) => {
    const { t } = useTranslation()
    const isConfirmed = useWatch({ name: "isConfirmed" })

    return (
      <div
        className={classNames("replace-attachment-overlay__step", {
          "replace-attachment-overlay__step--disabled": !isConfirmed
        })}
      >
        <Label variant="bold">
          <Icon name={IconName.COUNTER_TWO} size={IconSize.SMALL} />
          {t("Attachments.ReplaceOverlay.NewFile")}
        </Label>
        <ReplaceAttachmentOverlayFileInput
          newFile={newFile}
          disabled={!isConfirmed}
          onUpload={onUpload}
        />
      </div>
    )
  }
)
